<!-- Progress Bar -->
<mat-progress-bar *ngIf="loading | async"
                  class="progress-bar-fixed"
                  mode="indeterminate">
</mat-progress-bar>

<!-- Content -->
<router-outlet></router-outlet>